module.exports = __webpack_public_path__ + "static/media/icon-512-maskable.fe17cac9.png";